import React from "react";
import { FaHome, FaClock, FaComments, FaCarAlt, FaHandHoldingHeart, FaGift } from "react-icons/fa";

const benefits = [
  {
    icon: <FaHome />,
    title: "Comodidad sin desplazamientos",
    description:
      "No necesitas salir de tu casa ni perder tiempo en un lavadero convencional. Nosotros vamos directo a la puerta de tu hogar.",
  },
  {
    icon: <FaClock />,
    title: "Valoramos tus tiempos",
    description:
      "Agendamos el servicio en el horario que más te convenga, permitiéndote seguir con tu día sin interrupciones.",
  },
  {
    icon: <FaComments />,
    title: "Atención personalizada y flexible",
    description:
      "Contamos con un chat para conversar con cada cliente y aclarar todas las dudas sobre nuestros servicios.",
  },
  {
    icon: <FaCarAlt />,
    title: "Cuidado de tu vehículo",
    description: "Utilizamos productos de alta calidad.",
  },
  {
    icon: <FaHandHoldingHeart />,
    title: "Lavado detallado profesional",
    description:
      "Personal capacitado que ofrece un servicio óptimo y de total confianza.",
  },
  {
    icon: <FaGift />,
    title: "Promociones y programas de fidelidad",
    description:
      "Diversas opciones de servicios para fidelizar a nuestros clientes.",
  },
];

const Benefits: React.FC = () => {
  return (
    <section className="bg-[rgb(25,24,31)] text-white py-12 px-4">
      <h2 className="text-4xl font-bold text-center mb-8">Beneficios de Glowin</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {benefits.map((benefit, index) => (
          <div
            key={index}
            className="p-6 bg-[rgb(35,35,45)] rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
          >
            <div className="text-5xl text-yellow-500 mb-4 flex justify-center">
              {benefit.icon}
            </div>
            <h3 className="text-xl font-semibold mb-2 text-center">
              {benefit.title}
            </h3>
            <p className="text-base text-gray-300 text-center">{benefit.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Benefits;
